import { useEffect, useState } from "react";
import IMG from "../../assets/images/Download.jpeg";

export default function ScheduleTable() {
  const [schedule, setSchedule] = useState([]);
  useEffect(function () {
    async function fetchSchedule() {
      const response = await fetch("data/kiyg25-schedule.json");
      const data = await response.json();
      setSchedule(data);
      console.log("Schedule", data);
    }
    fetchSchedule();
  }, []);
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            {/* <th style={{ textAlign: "center" }}>क्रम</th> */}
            <th style={{ textAlign: "center" }}>खेल</th>
            <th style={{ textAlign: "center" }}>तिथि</th>
            <th style={{ textAlign: "center" }}>स्थल</th>
            <th style={{ textAlign: "center" }}>क्षेत्र</th>
            <th style={{ textAlign: "center" }}>कार्यक्रम</th>
          </tr>
        </thead>
        <tbody>
          {schedule?.map(function (item, index) {
            return (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#bfb" : "#fdd",
                  fontWeight: "bold",
                }}
              >
                {/* <td>{index + 1}</td> */}
                <td>
                  {!!item?.game?.schedule ? (
                    <a
                      href={item?.game?.schedule}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "underline", color: "blue" }}
                    >
                      {item?.game?.hi}
                    </a>
                  ) : (
                    item?.game?.hi
                  )}
                </td>
                <td>
                  {`${item?.start}`?.padStart(2, "0")} मई 2025 -{" "}
                  {`${item?.end}`?.padStart(2, "0")} मई 2025
                </td>
                <td>{item?.venue?.hi}</td>
                <td>{item?.place?.hi}</td>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {!!item?.scheduleLink ? (
                    <a href={item?.scheduleLink ?? "#"} target="_blank" rel="noreferrer">
                      <img
                        src={IMG}
                        alt="Download"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    "---"
                  )}
                </td>
              </tr>
            );
          })}
          {/* Add more rows as needed */}
        </tbody>
      </table>
    </div>
  );
}
